import * as api from '../../services/item/apiAttributeName';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';


export function* fetchListAttributeNameSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_ATTRIBUTE_NAME', callFetchListAttributeName, feathersApp);
}

function* callFetchListAttributeName(feathersApp, action) {
    const { silent, filters } = action;
    yield common.showProgressListTable(silent);
    try {
        const dataParams = { 
            filters,
            list_type: 'attribute_name'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield common.showErrorListTable(error);
    }
}


export function* saveAttributeNameSaga(feathersApp) {
  yield takeEvery("SAVE_ATTRIBUTE_NAME", callSaveAttributeName, feathersApp);
}
function* callSaveAttributeName(feathersApp, action) {
  const { tenant, user } = yield select();
  try{
      yield put({ type: 'SAVE_RECORD_INPROGRESS' });

      const params = { tenant, user, data: action.data };
      const result = yield call(api.saveAttributeName, feathersApp, params );
      yield common.doneSaveRecord( result, 'Attribute name was saved' );
      yield put({
        type: SagasType.SIMPLE_FORM_SET_DATA,
        data: result
      });
      yield callFetchListAttributeName(feathersApp, { silent: true });

  } catch (e){
    yield common.showErrorSaveRecord(e);
  }
}

export function* deleteAttributeNameFromListSaga(feathersApp) {
    yield takeEvery('DELETE_ATTRIBUTE_NAME_FROM_LIST', callDeleteAttributeNameFromList, feathersApp);
}

function* callDeleteAttributeNameFromList(feathersApp, action) {
    yield deleteAttributeName(feathersApp, action);
    yield delay(2000);
    yield callFetchListAttributeName(feathersApp, { silent: true });
}

function* deleteAttributeName(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if(id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deleteAttributeName, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.ATTRIBUTE_NAME }});
            yield callFetchListAttributeName(feathersApp, { silent: true });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* deleteAttributeNameSaga(feathersApp) {
    yield takeEvery('DELETE_ATTRIBUTE_NAME', callDeleteAttributeName, feathersApp);
}

function* callDeleteAttributeName(feathersApp, action) {
    const result = yield deleteAttributeName(feathersApp, action);
    yield delay(2000);
    if(result) {
        browserHistory.push('/admin/matrix/name');
    }
}

export function* fetchAttributeNameForEditSaga(feathersApp) {
    yield takeEvery('FETCH_ATTRIBUTE_NAME_BY_ID', callFetchAttributeNameForEdit, feathersApp);
}

function* callFetchAttributeNameForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id } = action;
    const docType = DocType.ATTRIBUTE_NAME;
    try {
        if(id) {
            yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchAttributeNameById, feathersApp, fetchParams);
            yield common.doneDataById(doc);
            yield put({
                type: SagasType.SIMPLE_FORM_SET_DATA,
                data: doc
            });              
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
